// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import {formatDateTime} from '../../../../../../utils/date'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Type' className='min-w-125px' />,
    accessor: 'type',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Level' className='min-w-125px' />
    ),
    accessor: 'level',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Available Status' className='min-w-125px' />
    ),
    accessor: 'availabilityStatusName',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Last Handle' className='min-w-125px' />
    ),
    id: 'lastHandle',
    Cell: ({...props}) => formatDateTime(props.data[props.row.index].lastHandle),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} />,
  },
]

export {usersColumns}
